module.exports = __webpack_public_path__ + "img/home-nav-icon-3.6fa5ad14.png";